// Vendored from gs-ui-templates/src/constants/common.ts:1075-1090 (sanitizeXSSHtml).
// Kept as its own file, rather than folded into constant.js, because it carries its
// own import (dompurify) that the rest of constant.js does not need.
import DOMPurify from "dompurify";

// Hoisted to module scope — rebuilding these ~60/~30-entry arrays on every call was wasted work
// on a hot, per-keystroke path (Content.js calls this from a useEffect keyed on the live
// body/header text). Values are unchanged from the original per-call literal.
const ALLOWED_TAGS_CONFIG = {
  ALLOWED_TAGS: ['a','abbr','address','article','b','bdi','bdo','blockquote','br','caption',
    'cite','code','col','colgroup','dd','del','details','dfn','div','dl','dt','em',
    'figcaption','figure','footer','h1','h2','h3','h4','h5','h6','header','hr','i',
    'img','ins','kbd','li','mark','ol','p','pre','q','rp','rt','ruby','s','samp',
    'section','small','span','strong','sub','summary','sup','table','tbody','td',
    'tfoot','th','thead','tr','u','ul','var','wbr','center','font','style'],
  ALLOWED_ATTR: ['align','alt','bgcolor','border','cellpadding','cellspacing','class',
    'color','cols','colspan','dir','face','headers','height','href','hspace','name',
    'rel','rows','rowspan','scope','size','span','src','start','style','summary',
    'tabindex','target','title','type','valign','vspace','width'],
  ALLOW_DATA_ATTR: false
};

export const sanitizeXSSHtml = (html) => DOMPurify.sanitize(html, { ...ALLOWED_TAGS_CONFIG });
